import React, { useState, useEffect } from 'react';
import { BulkUploadWizardShell } from './BulkUploadWizardShell';
import { AddQuestionDraftPanel } from '../../Shared/AddQuestionDraftPanel';

export const BulkUploadAddQuestionStep = ({
  currentStep = 1,
  steps,
  question = '',
  title = '',
  stimulusText = '',
  stimulusFiles = [],
  onQuestionChange,
  onTitleChange,
  onStimulusTextChange,
  onStimulusFilesChange,
  onBack,
  onClose,
  onContinue,
  onStepClick,
  isContinueDisabled,
  fullPage = false,
}) => {
  const [questionValue, setQuestionValue] = useState(question);
  const [titleValue, setTitleValue] = useState(title);

  useEffect(() => {
    setQuestionValue(question);
  }, [question]);

  useEffect(() => {
    setTitleValue(title);
  }, [title]);

  // Test data attributes
  const hasTitle = titleValue.trim().length > 0;
  const hasQuestion = questionValue.trim().length > 0;
  const hasStimulus = (stimulusText?.length || 0) > 0 || (stimulusFiles?.length || 0) > 0;
  // The caller's flag ADDS a reason to hold — it does not replace the ones this
  // step already has. Overriding meant the in-flight guard (BU-01) would also
  // have unlocked Continue on an empty form.
  const continueDisabled = Boolean(isContinueDisabled) || !hasTitle || !hasQuestion;

  return (
    <BulkUploadWizardShell
      currentStep={currentStep}
      steps={steps}
      onBack={onBack}
      onClose={onClose}
      onContinue={() =>
        onContinue?.({ title: titleValue.trim(), question: questionValue.trim() })
      }
      onStepClick={onStepClick}
      isContinueDisabled={continueDisabled}
      fullPage={fullPage}
      data-component="bulk-upload-question"
      data-unit="bulk-upload-step-0"
      data-has-title={hasTitle}
      data-has-question={hasQuestion}
      data-has-stimulus={hasStimulus}
      data-title-length={titleValue.trim().length}
      data-question-length={questionValue.trim().length}
      data-stimulus-files={stimulusFiles?.length || 0}
      data-continue-disabled={continueDisabled}
    >
      <AddQuestionDraftPanel
        idPrefix="bulk-upload"
        title={titleValue}
        question={questionValue}
        stimulusText={stimulusText}
        stimulusFiles={stimulusFiles}
        onTitleChange={(next) => {
          setTitleValue(next);
          onTitleChange?.(next);
        }}
        onQuestionChange={(next) => {
          setQuestionValue(next);
          onQuestionChange?.(next);
        }}
        onStimulusTextChange={onStimulusTextChange}
        onStimulusFilesChange={onStimulusFilesChange}
      />
    </BulkUploadWizardShell>
  );
};
